import { CustomerType } from '@modules/ticket-fares-store/client/src';
import { TicketSelectorPanelProps } from '@modules/ticket-search/components/ticket-accordion-panel/ticketSelectorPanelProps.interface';
import { RadioGroupItemProps, RadioGroupProps } from '@nx-ng/types';

export const CUSTOMER_TYPES_LOOKUP: RadioGroupProps<string> = {
  groupName: 'customer',
  standard: [
    {
      titleKey: 'customer_type_adult_title',
      value: '1',
      action: {
        actionLabelKey: '',
        modalType: 'text',
        actionStyle: 'info',
      },
    },
    {
      titleKey: 'customer_type_18andUnder_title',
      value: '2',
      action: {
        actionLabelKey: '',
        modalType: 'text',
        actionStyle: 'info',
      },
    },
    {
      titleKey: 'customer_type_student_title',
      value: '3',
      action: {
        actionLabelKey: '',
        modalType: 'text',
        actionStyle: 'info',
      },
    },
  ],
};

export const buildCustomerTypeOptions = (
  customerTypes: CustomerType[] = []
): TicketSelectorPanelProps => {
  const customerIds =
    customerTypes?.map((customerType: CustomerType) => customerType.typeCode) ||
    [];

  const items: RadioGroupProps<string> = {
    ...CUSTOMER_TYPES_LOOKUP,
    standard: CUSTOMER_TYPES_LOOKUP.standard.filter(
      (lookupValues: RadioGroupItemProps<string>) =>
        customerIds.includes(lookupValues.value)
    ),
  };

  return {
    category: 'customer',
    selectKey: 'label_select_ticket_type',
    radio: items,
  };
};
